import { render, staticRenderFns } from "./incomming.vue?vue&type=template&id=430b0a02&"
import script from "./incomming.vue?vue&type=script&lang=js&"
export * from "./incomming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports